import EndFrameAnimation from './endFrameAnimation.ui';

export default EndFrameAnimation;
